import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgIf, NgSwitchCase } from "@angular/common";
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, ValidatorFn } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FilterType } from "../../../../../../../api/src/data-source/models/filter.model";
import { BaseInputComponent } from "../base-input/base-input.component";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: 'app-date-range',
    standalone: true,
	imports: [
		MatDatepickerModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		NgSwitchCase,
		NgIf,
		MatButtonModule
	],
    templateUrl: './date-range.component.html',
    styleUrl: './date-range.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangeComponent extends BaseInputComponent implements OnDestroy, OnInit {
    @Input() dateFormat: string = "MM/DD/YYYY";
	@Input() showClearButton: boolean = true;

    @Input() secondControlName?: string;
    @Input() currentSecondValue?: any;

	private	debounceSubject: Subject<any> = new Subject<any>();
	protected readonly FilterType = FilterType;

	ngOnInit() {
		super.ngOnInit();


		this.debounceSubject.asObservable().pipe(
			takeUntil(this._unsubscribe),
			debounceTime(this.debounceTime)
		).subscribe(() => {
			this.emitDateValues()
		})
	}

	initializeForm(currentValue?: any, validators?: ValidatorFn | ValidatorFn[]) {
		this.form = new UntypedFormGroup({
			[this.controlName]: new UntypedFormControl(
				{ value: currentValue || this.currentValue || this.parentForm?.get(this.controlName)?.value, disabled: this.isDisabled },
				validators || this.validators || this.parentForm?.get(this.controlName)?.validator
			),
			[this.secondControlName]: new UntypedFormControl(
				{ value: currentValue || this.currentSecondValue || this.parentForm?.get(this.secondControlName)?.value, disabled: this.isDisabled },
				validators || this.validators || this.parentForm?.get(this.secondControlName)?.validator
			)
		});
	}

	public changeDatesWithDebounce() {
		this.debounceSubject.next(true)
	}

	private emitDateValues() {
		this.valueChange.emit(this.form.value);
	}

	initializeFormListener() {
		/** skip base class form event listeners initialization and fire the event by hand via (changeDate) event **/
	}

    clearForm() {
        this.form.reset();
		this.valueChange.emit({[this.controlName]: null, [this.secondControlName]: null });
    }

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
